import React from "react";
import Container from "../../../container";
import "./index.scss";

export default function Checkbox ({label, value, setValue}) {
    return <Container onClick={() => setValue(!value)} className="checkbox-container">
          <div className={`checkbox ${value ? "checked" : ""}`}/>
          <div className="label-container">{label}</div>
    </Container>
}